export function getFastSpringPageUrl() {
    const loginInformation = JSON.parse(localStorage.getItem("loginInformation")).objectData;
    if (loginInformation.id == null || loginInformation.id === '') {
        throw new Error('id is required for FastSpring subscription');
    }
    return window.location.origin + "/FastSpringPage.html?grqerewrfa=" + encodeURIComponent(loginInformation.id);
}

export function openFastSpringPage() {
    window.location.href = getFastSpringPageUrl();
}
